const injectTypography = theme => {
  const fontWeightRegular = 450;
  const fontWeightBold = 650;
  const fontFamily = '"Inter", sans-serif';
  const typography = {
    fontFamily,
    /**
     * This is default @mui variant. Styles from this variants are applied
     * to <body /> element. All the other variants inherit fontFamily from body
     **/
    body1: {
      fontFamily,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: fontWeightRegular,
      lineHeight: 20 / 13
    },
    // Custom Variants
    displayExtraLarge: {
      fontFamily,
      fontSize: theme.typography.pxToRem(46),
      fontWeight: fontWeightBold,
      lineHeight: 56 / 46,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(29),
        lineHeight: 36 / 29
      }
    },
    displayLarge: {
      fontFamily,
      fontSize: theme.typography.pxToRem(36),
      fontWeight: fontWeightBold,
      lineHeight: 48 / 36,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(25),
        lineHeight: 28 / 25
      }
    },
    displayMedium: {
      fontFamily,
      fontSize: theme.typography.pxToRem(28),
      fontWeight: fontWeightBold,
      lineHeight: 40 / 28,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(22),
        lineHeight: 28 / 22
      }
    },
    displaySmall: {
      fontFamily,
      fontSize: theme.typography.pxToRem(24),
      fontWeight: fontWeightRegular,
      lineHeight: 32 / 24,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(18),
        lineHeight: 24 / 18
      }
    },
    heading: {
      fontFamily,
      fontSize: theme.typography.pxToRem(20),
      fontWeight: fontWeightBold,
      lineHeight: 28 / 20
    },
    subheader: {
      fontFamily,
      fontSize: theme.typography.pxToRem(11),
      fontWeight: fontWeightBold,
      lineHeight: 16 / 11
    },
    body02: {
      fontFamily,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: fontWeightBold,
      lineHeight: 20 / 13
    },
    body01: {
      fontFamily,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: fontWeightRegular,
      lineHeight: 20 / 13
    },
    caption: {
      fontFamily,
      fontSize: theme.typography.pxToRem(11),
      fontWeight: fontWeightRegular,
      lineHeight: 16 / 11,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: 20 / 14
      }
    }
  };
  Object.assign(theme.typography, typography);
};

export { injectTypography };
